import { JourneyType, SearchFormInputs, INITIAL_PASSENGERS } from "src/Modules/Flights/constants";
import {
  PASSENGER_KEYS_MAP,
  PASSENGER_DATA_MAP,
  PassengerClassificationType,
  SegmentAddition,
  PassengerBasicData,
  SSR_OPTIONS,
} from "src/Modules/Flights/constants/JourneyDetails";

const buildFlightSSR = () => {
  return SSR_OPTIONS
    .filter(opt => opt?.ssrSelectionType === "flight")
    .reduce((acc, opt) => {
      if (!opt) return acc;
      acc[opt.value] = {};
      return acc;
    }, {} as Record<string, any>);
};

const buildSegmentSSR = () => {
  return SSR_OPTIONS
    .filter(opt => opt?.ssrSelectionType === "segment")
    .reduce((acc, opt) => {
      if (!opt) return acc;
      acc[opt.value] = {};
      return acc;
    }, {} as Record<string, any>);
};


const generateInitialPassengerValues = (searchObject: SearchFormInputs, journeySearchData: JourneyType) => {
  const structure = getSegmentFlightsStructure(journeySearchData);
  const searchObjectPassengers = searchObject.passengers ?? INITIAL_PASSENGERS;
  const passengers = Object.entries(searchObjectPassengers)
    .sort(([key1], [key2]) => {
      const orderDiff =
        PASSENGER_KEYS_MAP[key1 as keyof typeof searchObjectPassengers].order -
        PASSENGER_KEYS_MAP[key2 as keyof typeof searchObjectPassengers].order;
      return orderDiff;
    })
    .flatMap(([key, value]) => {
      const type = PASSENGER_KEYS_MAP[key as keyof typeof searchObjectPassengers].value as PassengerClassificationType;
      return Array.from({ length: value }).map(() => ({
        type,
        basicData: PASSENGER_DATA_MAP[type].reduce<Partial<PassengerBasicData>>((prev, next) => {
          return {
            ...prev,
            [next.name]: next.initialValue,
          };
        }, {}) as PassengerBasicData,
        segments: structure,
      }));
    });
  const adults = passengers.filter((passenger) => passenger.type === "Adult");
  if (adults.length === 1) {
    adults[0].basicData.isLeadPax = true;
  }
  return {
    passengers,
  };
};

const getSegmentFlightsStructure = (journeySearchData: JourneyType): SegmentAddition[] => {
  return journeySearchData.segments.map((segment) => ({
    flights: segment.flights.map((flight) => ({
      flight: { ...flight },
      ssr: buildFlightSSR(),
    })),
    ssr: buildSegmentSSR(),
    segment:{...segment}
  }));
};

export { generateInitialPassengerValues };
